import React from 'react'
import { ViewPropTypes, View } from 'react-native'
import Modal from 'react-native-modal'

import PropTypes from 'prop-types'

import styles from './Modal.Styles'

function VfModal(props) {
  const {
    visible,
    close,
    children,
    type,
    style,
    contentContainerStyle,
    ...rest
  } = props

  const swipeDirection = {
    normal: 'down',
    full: null,
  }

  return (
    <View style={styles.modalContainer}>
      <Modal
        backdropOpacity={0.5}
        onSwipeComplete={() => close()}
        onBackdropPress={() => close()}
        swipeDirection={swipeDirection[type]}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={styles.modal}
        isVisible={visible}
        {...rest}
      >
        <View style={[styles.main, styles['main_' + type], style]}>
          <View style={[styles.content, contentContainerStyle]}>{children}</View>
        </View>
      </Modal>
    </View>
  )
}

VfModal.defaultProps = {
  type: 'normal',
  style: {},
}

VfModal.propTypes = {
  visible: PropTypes.bool,
  type: PropTypes.oneOf(['normal', 'full']),
  children: PropTypes.node,
  close: PropTypes.func,
  style: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style),
  ]),
  contentContainerStyle: PropTypes.oneOfType([
    ViewPropTypes.style,
    PropTypes.arrayOf(ViewPropTypes.style),
  ]),
  scrollable: PropTypes.bool,
}

export default VfModal
